<template>
  <div>
    <div class="btn-box">
      <template v-if="showTitle">
        <p></p>
        <h1>设定重点展示字段</h1>
      </template>
    </div>
    <div style="display:flex;">
      <div class="left-menu">
        <div class="group-btn">
          <div class="flex" v-if="bigStatus">
            <el-button type="primary" size="small" :disabled='!Boolean(currentData.id)'
              @click="addFieldClick">新增字段</el-button>
            <el-button type="primary" :disabled='!Boolean(currentData.id)' size="small"
              @click="managementGroupClick">新增分组</el-button>
            <el-popover ref="group0" placement="top" width="180">
              <p>删除后已经应用的字段将全部被删除，请谨慎操作</p>
              <div style="text-align: right; margin: 5px">
                <el-button size="mini" type="text" @click="doClose(0, true)">取消</el-button>
                <el-button type="primary" size="mini" v-preventReClick @click="deleteClick()">确定</el-button>
              </div>

              <el-button type="danger" slot="reference"
                v-if="currentData.name != '无分组' && currentData.name != '自定义分组' && this.currentData.canDeleted != false"
                :disabled='!Boolean(currentData.id)' size="small" style="width:80px;margin-left:10px;"
                @click="deleteFieldClick">删除</el-button>

              <el-button type="danger" slot="reference" v-else :disabled='true' size="small"
                style="width:80px;margin-left:10px;" @click="deleteFieldClick">删除</el-button>
            </el-popover>
          </div>
          <div class="flex" v-else>
            <el-button type="primary" size="small" :disabled='true' @click="addFieldClick">新增字段</el-button>
            <el-button type="primary" :disabled='true' size="small" @click="managementGroupClick">新增分组</el-button>
            <el-button type="danger" slot="reference" :disabled='true' size="small" style="width:80px;margin-left:10px;"
              @click="deleteFieldClick">删除</el-button>
          </div>
          <div class="flex">
            <div class="upload-box" v-if="bigStatus">
              <el-upload class="avatar-uploader" action="##" :http-request="uploadServerLog" :show-file-list="false">
              </el-upload>
              <el-button type="primary" size="small" class="uploadBtn" style="margin-left:0px;">批量导入</el-button>
            </div>
            <div class="upload-box" v-else>
              <el-button type="primary" size="small" class="uploadBtn" :disabled="true"
                style="margin-left:0px;">批量导入</el-button>
            </div>
            <a :href='imgPath + "focusFieldConfig/demo/资料配置批量导入样例.xlsx"' download="资料配置批量导入样例.xlsx" class="downloadClass">
              <img src="@/assets/images/download-icon.png" alt="">下载样例</a>
          </div>
        </div>
        <div class="tree-box-content">
          <el-tree ref="treeRefNo" :data="menuNo" node-key="id" default-expand-all :allow-drop="allowDrop"
            :allow-drag="allowDrag" :current-node-key="currentKey" icon-class="none" :props="defaultPropsNew"
            v-if="currentKeyFlag">
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <!-- {{ data }} -->
              <i class="svgIconc" v-if="data.groupLevel == 2"></i>
              <span class="svgIconc-icon" v-else>
                <i class="svgIconb" v-show="!data.fold" @click="handleFold(data, true)"></i>
                <i class="svgIcona" v-show="data.fold" @click="handleFold(data, false)"></i>
              </span>
              <span class="label-name" v-show="!data.fold" @click="nodeClick(data, true)" :title="node.label || '-'">{{
                node.label }}</span>
              <span class="label-name" v-show="data.fold" @click="nodeClick(data, false)" :title="node.label || '-'">{{
                node.label }}</span>
            </div>
          </el-tree>
          <el-tree ref="treeRef" :data="menu" node-key="id" default-expand-all @node-drag-start="handleDragStart"
            @node-drag-enter="handleDragEnter" @node-drag-leave="handleDragLeave" @node-drag-over="handleDragOver"
            @node-drag-end="handleDragEnd" @node-drop="handleDrop" :draggable="bigStatus" :allow-drop="allowDrop"
            :allow-drag="allowDrag" :current-node-key="currentKeyNew" highlight-current icon-class="none"
            :expand-on-click-node="false" :props="defaultProps">
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <!-- <i class="svgIconc" v-if="data.groupLevel == 2"></i>
              <span class="svgIconc-icon" v-else>
                <i class="svgIconb" v-show="!data.fold" @click="handleFold(data, true)"></i>
                <i class="svgIconb" v-show="data.fold" @click="handleFold(data, false)"></i>
              </span>
              <span class="label-name" v-show="!data.fold" @click="nodeClick(data, true)"
                :title="node.label || '-'">{{ node.label }}</span>
              <span class="label-name" v-show="data.fold" @click="nodeClick(data, false)"
                :title="node.label || '-'">{{ node.label }}</span> -->
              <div class="custom-tree-node" v-if="data.label != '自定义分组'">
                <i class="svgIconc" v-if="data.groupLevel == 2"></i>
                <span class="svgIconc-icon" v-else>
                  <i class="svgIconb" v-show="!data.fold" @click="handleFold(data, true)"></i>
                  <i class="svgIconb" v-show="data.fold" @click="handleFold(data, false)"></i>
                </span>
                <span class="label-name" v-show="!data.fold" @click="nodeClick(data, true)" :title="node.label || '-'">{{
                  node.label }}</span>
                <span class="label-name" v-show="data.fold" @click="nodeClick(data, false)" :title="node.label || '-'">{{
                  node.label }}</span>
              </div>
              <div class="custom-tree-node" v-else>
                <i class="svgIconc" v-if="data.groupLevel == 2"></i>
                <span class="svgIconc-icon" v-else>
                  <i class="svgIconb" v-show="!data.fold" @click.stop></i>
                  <i class="svgIconb" v-show="data.fold" @click.stop></i>
                </span>
                <span class="label-name" v-show="!data.fold" @click.stop :title="node.label || '-'">{{ node.label
                }}</span>
                <span class="label-name" v-show="data.fold" @click.stop :title="node.label || '-'">{{ node.label }}</span>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
      <div class="table-content">
        <!-- <div class="table-content-box" v-if="!bigStatus"></div> -->
        <el-table :data="dataList" v-show="bigStatus && moveFlag" class="el-table-box" row-key="id" height="580"
          width="100%" :header-cell-style="{
            background: '#FAFAFA',
            color: '#333333',
            fontWeight: 'bold'
          }" tooltip-effect="dark" ref="multipleTable1" fit highlight-current-row
          :row-class-name="row => row.row.canDeleted == false ? 'not-sort' : ''">
          <el-table-column align="center" label="" width="50">
            <template slot-scope="scope" v-if="bigStatus">
              <div class="table-first">
                <img src="@/assets/images/drag-icon.png" alt="">
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="字段名称" prop="fieldName">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              {{ scope.row.fieldName ? scope.row.fieldName : '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="对应标准字段" prop="standardFieldName">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              <!-- <span v-if="scope.row.standardFieldCategoryName">{{scope.row.standardFieldCategoryName}}-</span> -->
              <span>{{ scope.row.contactStandardFieldName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="同义词字段" width="90" prop="standardFieldSynonyms" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.standardFieldSynonyms ? scope.row.standardFieldSynonyms : '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注" prop="fieldDescription" show-overflow-tooltip>
            <template slot-scope="scope" v-if="!scope.row.deleted">
              {{ scope.row.fieldDescription ? scope.row.fieldDescription : '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="来源" prop="source" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" width="200" label="操作">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              <div v-if="bigStatus">
                <!-- <el-popover :ref="scope.$index" placement="top" width="180"> -->
                <el-popover :ref="`popover-${scope.$index}`" placement="top" width="180">
                  <p>确定取消重点字段嘛？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="doCloseNew(scope.$index, false)">取消</el-button>
                    <el-button type="primary" size="mini" @click="confimClick(scope.row, scope.$index)">确定</el-button>
                  </div>
                  <el-button type="text" :disabled='disabled' slot="reference">取消重点字段</el-button>
                </el-popover>
                <!-- <el-button type="text" style="margin-left:10px" v-if="scope.row.id && scope.row.editFlag"
                  @click="editClick(scope.row,scope.$index)">编辑
                </el-button> -->
                <el-button type="text" style="margin-left:10px" v-if="scope.row.editFlag"
                  @click="editClick(scope.row, scope.$index)">编辑
                </el-button>
                <!-- <el-button type="text" style="margin-left:10px;color:#c0c4cc;"
                  v-if="scope.row.id && !scope.row.editFlag">编辑
                </el-button> -->
                <el-button type="text" style="margin-left:10px;color:#c0c4cc;" v-if="!scope.row.editFlag">编辑
                </el-button>
              </div>
              <div v-else>
                <el-button type="text" :disabled='true'>取消重点字段</el-button>
                <!-- <el-button type="text" v-if="scope.row.id" style="margin-left:10px" :disabled='true'>编辑
                </el-button> -->
                <el-button type="text" style="margin-left:10px" :disabled='true'>编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="140" label="字段识别规则">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              <div style="display: flex;align-items: center;justify-content: center;position: relative;cursor: pointer;">
                <el-popover placement="left" trigger="hover"
                  style="border:none !important;box-shadow: none !important;display:block !important;"
                  v-if="scope.row.focusFieldRuleList && scope.row.focusFieldRuleList.length > 0">
                  <template>
                    <div class="tips-box" v-if="scope.row.focusFieldRuleList && scope.row.focusFieldRuleList.length > 0">
                      <div class="tips-box-center">
                        <div class="tips-box-content">
                          <div v-for="(item, indexs) in scope.row.focusFieldRuleList" :key="indexs"
                            :title="item.valueLogic">{{ indexs + 1 }}. {{ item.valueLogic }}
                          </div>
                        </div>
                      </div>
                      <span class="san-icon"></span>
                    </div>
                  </template>
                  <div slot="reference" class="set-content">
                    <div style="display: flex;align-items: center;justify-content: center;position: relative;">
                      <el-button type="text" style="margin-left:10px" v-if="scope.row.editFlag"
                        @click="configClick(scope.row, scope.$index)">配置
                      </el-button>
                      <el-button type="text" style="margin-left:10px;color:#c0c4cc;" v-if="!scope.row.editFlag">配置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
                <el-button type="text" style="margin-left:10px"
                  v-if="scope.row.focusFieldRuleList && scope.row.focusFieldRuleList.length <= 0 && scope.row.editFlag"
                  @click="configClick(scope.row, scope.$index)">配置
                </el-button>
                <!-- <el-button type="text" style="margin-left:10px;color:#c0c4cc;"
                  v-if="bigStatus && scope.row.focusFieldRuleList  && scope.row.focusFieldRuleList.length <= 0 && !scope.row.editFlag">配置6
                </el-button> -->
                <el-button type="text" style="margin-left:10px;color:#c0c4cc;"
                  v-if="scope.row.focusFieldRuleList && scope.row.focusFieldRuleList.length <= 0 && !scope.row.editFlag">配置
                </el-button>
                <!-- <el-button type="text" style="margin-left:10px" v-if="!bigStatus" :disabled='true'>配置5
                </el-button> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="focusFieldPushIntervalList" width="140" label="指标值推送区间"
            v-if="statusType != 'platform'">
            <template slot-scope="scope">
              <div class="" v-if="scope.row.focusFieldPushIntervalList.length > 0">
                <div v-for="(item, index) in scope.row.focusFieldPushIntervalList" :key="index"><span v-if="item.lower">{{
                  item.lower }}-</span>{{ item.upper }} <span v-if="item.unit">{{ item.unit }}</span></div>
              </div>
              <div v-else>
                <div></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-table :data="dataList" v-show="!bigStatus || moveFlag" row-key="id" height="580" width="100%" -->
        <el-table :data="dataList" v-show="(bigStatus && !moveFlag) || (!bigStatus && moveFlag)" row-key="id" height="580"
          width="100%" :header-cell-style="{
            background: '#FAFAFA',
            color: '#333333',
            fontWeight: 'bold'
          }" tooltip-effect="dark" ref="multipleTable2" fit highlight-current-row>
          <el-table-column align="center" label="" width="50">
            <template slot-scope="scope" v-if="bigStatus">
              <div class="table-first">
                <img src="@/assets/images/drag-icon.png" alt="">
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="字段名称" prop="fieldName">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              {{ scope.row.fieldName ? scope.row.fieldName : '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="对应标准字段" prop="standardFieldName">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              <!-- <span v-if="scope.row.standardFieldCategoryName">{{scope.row.standardFieldCategoryName}}-</span> -->
              <span>{{ scope.row.contactStandardFieldName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="同义词字段" width="90" prop="standardFieldSynonyms" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.standardFieldSynonyms ? scope.row.standardFieldSynonyms : '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注" prop="fieldDescription" show-overflow-tooltip>
            <template slot-scope="scope" v-if="!scope.row.deleted">
              {{ scope.row.fieldDescription ? scope.row.fieldDescription : '--' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="来源" prop="source" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" width="150" label="操作">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              <div v-if="bigStatus">
                <el-popover :ref="scope.$index" placement="top" width="120">
                  <p>确定取消重点字段嘛？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="doCloseNew(scope.$index, false)">取消</el-button>
                    <el-button type="primary" size="mini" @click="confimClick(scope.row, scope.$index)">确定</el-button>
                  </div>
                  <el-button type="text" :disabled='disabled' slot="reference">取消重点字段</el-button>
                </el-popover>
                <!-- <el-button type="text" style="margin-left:10px" v-if="scope.row.id"
                  @click="editClick(scope.row,scope.$index)">编辑
                </el-button> -->
                <el-button type="text" style="margin-left:10px" @click="editClick(scope.row, scope.$index)">编辑
                </el-button>
              </div>
              <div v-else>
                <el-button type="text" :disabled='true'>取消重点字段</el-button>
                <!-- <el-button type="text" v-if="scope.row.id" style="margin-left:10px;color:#c0c4cc;">编辑
                </el-button> -->
                <el-button type="text" style="margin-left:10px;color:#c0c4cc;">编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="140" label="字段识别规则">
            <template slot-scope="scope" v-if="!scope.row.deleted">
              <div style="display: flex;align-items: center;justify-content: center;position: relative;cursor: pointer;">
                <el-popover placement="left" trigger="hover"
                  style="border:none !important;box-shadow: none !important;display:block !important;"
                  v-if="scope.row.focusFieldRuleList && scope.row.focusFieldRuleList.length > 0">
                  <template>
                    <div class="tips-box" v-if="scope.row.focusFieldRuleList && scope.row.focusFieldRuleList.length > 0">
                      <div class="tips-box-center">
                        <div class="tips-box-content">
                          <div v-for="(item, indexs) in scope.row.focusFieldRuleList" :key="indexs"
                            :title="item.valueLogic">{{ indexs + 1 }}. {{ item.valueLogic }}
                          </div>
                        </div>
                      </div>
                      <span class="san-icon"></span>
                    </div>
                  </template>
                  <div slot="reference" class="set-content">
                    <div style="display: flex;align-items: center;justify-content: center;position: relative;">
                      <el-button type="text" style="margin-left:10px;color:#c0c4cc;" v-if="!bigStatus">配置
                      </el-button>
                      <!-- <el-button type="text" style="margin-left:10px;" v-if="scope.row.id && bigStatus" @click="configClick(scope.row,scope.$index)"
                        >配置
                      </el-button> -->
                      <el-button type="text" style="margin-left:10px;" v-if="bigStatus"
                        @click="configClick(scope.row, scope.$index)">配置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
                <!-- <el-button type="text" style="margin-left:10px"
                  v-if="bigStatus && scope.row.focusFieldRuleList  && scope.row.focusFieldRuleList.length <= 0"
                  :disabled='!scope.row.editFlag || disabled' @click="configClick(scope.row,scope.$index)">配置
                </el-button> -->
                <div v-if="scope.row.focusFieldRuleList && scope.row.focusFieldRuleList.length <= 0">
                  <el-button type="text" style="margin-left:10px;color:#c0c4cc;" v-if="!bigStatus">配置</el-button>
                  <!-- <el-button type="text" style="margin-left:10px;" @click="configClick(scope.row,scope.$index)"
                  v-if="scope.row.id && bigStatus">配置
                  </el-button> -->
                  <el-button type="text" style="margin-left:10px;" @click="configClick(scope.row, scope.$index)"
                    v-if="bigStatus">配置
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="focusFieldPushIntervalList" width="140" label="指标值推送区间"
            v-if="statusType != 'platform'">
            <template slot-scope="scope">
              <div class="" v-if="scope.row.focusFieldPushIntervalList.length > 0">
                <div v-for="(item, index) in scope.row.focusFieldPushIntervalList" :key="index"><span v-if="item.lower">{{
                  item.lower }}-</span>{{ item.upper }} <span v-if="item.unit">{{ item.unit }}</span></div>
              </div>
              <div class="" v-else>
                <div></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增字段 -->
    <el-dialog v-if="fieldShow" :title="editFlagStatus ? '编辑字段' : '新增字段'" width="763px" custom-class="reject-dialog"
      :visible="true" :close-on-click-modal="false" :before-close="handleCurClose">
      <div>
        <el-form ref="form" :model="form" :rules="formRules" label-width="150px">
          <el-form-item label="字段名称：" prop="fieldName">
            <el-input type="textarea" maxlength="50" v-model.trim="form.fieldName" placeholder="请输入字段名称" size="medium"
              @input="fieldNameInput" @keydown.enter.native="handleTextareaKeydown" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="标准字段：" prop="standardFieldId">
            <el-select ref="inspectionRef" v-model="form.standardFieldId" placeholder="请选择检验项目" filterable remote
              reserve-keyword value-key="id" @change="selectMethod" v-elSelectloadMore="loadmoreInspect"
              :remote-method="val => { remoteInspectItemMethod(val); }" @focus="selectFocus" style="width:100%" clearable>
              <el-option v-for="(item, index) in standardList" :key="index" :disabled='item.disabled'
                :label="item.mergeName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="statusType != 'platform'">
            <el-form-item label="指标值区间：" v-if="resultProperty != null && resultProperty != 2">
              <!-- 定量 resultProperty=1  定性 resultProperty = 0 -->
              <div class="index-value-box">
                <div v-if="form.focusFieldPushIntervalList && form.focusFieldPushIntervalList.length > 0">
                  <div class="index-value-box-item" v-for="(item, index) in form.focusFieldPushIntervalList" :key="index">
                    <!-- onkeyup="value=value.replace(/^\D (\d (?:.\d{0,2})?). 1')" -->
                    <!-- <el-input type="text" v-model.trim="item.lower" maxlength="4"
                    onkeyup="this.value=this.value.replace(/\D/g,'')" placeholder="请输入" size="medium" style="width:100px;"
                    v-if="resultProperty == 1"></el-input> -->
                    <el-input type="text" v-model.trim="item.lower" maxlength="6"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入" size="medium"
                      style="width:150px;" v-if="resultProperty == 1"></el-input>
                    <span v-if="resultProperty == 1">-</span>
                    <!-- <el-input type="text" v-model.trim="item.upper" maxlength="4"
                    onkeyup="this.value=this.value.replace(/\D/g,'')" placeholder="请输入" size="medium"
                    style="width:100px;margin-right:10px;" v-if="resultProperty == 1"></el-input> -->
                    <el-input type="text" v-model.trim="item.upper" maxlength="6"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入" size="medium"
                      style="width:150px;margin-right:10px;" v-if="resultProperty == 1"></el-input>
                    <el-select v-model="item.unit" clearable filterable size="medium" placeholder="请选择"
                      style="width:160px;" v-if="resultProperty == 1">
                      <!-- <el-option label="单位" value="1">
                    </el-option> -->
                      <el-option v-for="(item, index) in unitList" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                    <!-- <el-autocomplete class="inline-input" style="width:180px" v-model="item.unit"
                    :fetch-suggestions="queryDepartment" placeholder="请选择" :trigger-on-focus="false"></el-autocomplete> -->
                    <el-select v-model="item.unit" clearable filterable size="medium" placeholder="请选择"
                      :style="resultProperty == 1 ? 'width:110px' : 'width:90%'" v-if="resultProperty == 0">
                      <!-- <el-option label="阴" value="1"></el-option> -->
                      <el-option v-for="(item, index) in referencesList" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                    <span class="deleteIndexValue" @click="deleteIndexValueQuantitativemClick(index)">删除</span>
                  </div>
                </div>
                <div class="addIndexValue" @click="addIndexValueQuantitativemClick"
                  v-if="resultProperty == 1 && form.focusFieldPushIntervalList.length < 5">+ 加一条</div>
                <div class="addIndexValue" @click="addIndexValueQuantitativemClick"
                  v-if="resultProperty == 0 && form.focusFieldPushIntervalList.length < 1">+ 加一条</div>
              </div>

              <!-- <el-autocomplete
          class="inline-input"
          style="width:100%"
          v-model="ruleForm.departmentName"
          :fetch-suggestions="queryDepartment"
          placeholder="请输入关键词搜索科室"
          :trigger-on-focus="false"
        ></el-autocomplete> -->
              <!-- 定性 -->
              <!-- <div class="index-value-box" v-if="resultProperty == 0">
              <div class="index-value-box-item" v-for="(item,index) in form.indexValueListQuantitatives" :key="index">
                <el-select v-model="item.unit" clearable filterable size="medium" placeholder="请选择"
                  style="width:110px;">
                  <el-option label="单位" value="1">
                  </el-option>
                </el-select>
                <span>推送至</span>
                <el-select v-model="item.fourValue" clearable filterable size="medium" placeholder="请选择"
                  style="width:110px;">
                  <el-option label="医生" value="1">
                  </el-option>
                  <el-option label="疗管" value="2"></el-option>
                  <el-option label="医生和疗管" value="3">
                  </el-option>
                </el-select>
                <span class="deleteIndexValue" @click="deleteIndexValueQuantitativesClick(index)">删除</span>
              </div>
              <div class="addIndexValue" @click="addIndexValueQuantitativesClick"
                v-if="form.indexValueListQuantitatives.length < 1">+ 加一条</div>
            </div> -->
            </el-form-item>
          </div>
          <el-form-item label="备注：">
            <el-input type="textarea" maxlength="200" v-model.trim="form.fieldDescription" placeholder="请输入备注"
              size="medium" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="单据样例：">
            <BaseUploadFile :fileSize="50" :isShowTip="false" :fileType="['png', 'jpg']" :size="80" :height="80"
              :beforeRemove="beforeRemovePicBtn" :responseFn="handleIntroChangeBtn" :action="VUE_APP_WECHATBASE_URL"
              :data="{ path: 'focusFieldConfig/billDemo', type: 'image', mediaId: '' }" v-model="form.billDemoUrl">
            </BaseUploadFile>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="text-align:center">
        <el-button size="small" style="width:110px" @click="handleReset">重置</el-button>
        <el-button size="small" type="primary" style="width:110px" @click="handleConfirm('form')">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="managementGroupShow" title="新增分组" custom-class="reject-dialog" :visible="true"
      :close-on-click-modal="false" width='60%' :before-close="managementGroupClose">
      <div class="management-box" style="overflow: hidden;">
        <div class="">
          <el-form ref="groupForm" :model="groupForm" :rules="groupFormRules" label-width="150px">
            <el-form-item label="选择分组：" prop="status">
              <div class="label-item">
                <el-radio-group v-model="groupForm.groupLevel" @change="groupChange">
                  <el-radio :label="1">一级</el-radio>
                  <el-radio :label="2">二级</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item label="一级分组名称：" prop="groupName" v-if="groupForm.groupLevel == 1">
              <el-input maxlength="30" v-model.trim="groupForm.groupName" placeholder="请输入一级分组名称" size="medium">
              </el-input>
            </el-form-item>
            <el-form-item label="一级分组名称：" prop="groupParentId" v-if="groupForm.groupLevel == 2">
              <el-select @change="levelOneGroupChange" v-model="groupForm.groupParentId" clearable filterable
                size="medium" placeholder="请输入一级分组名称">
                <el-option v-for="item in levelOneGroupList" :key="item.id" :label="item.groupNameNew" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级分组名称：" prop="groupName" v-if="groupForm.groupLevel == 2">
              <el-input maxlength="30" v-model.trim="groupForm.groupName" placeholder="请输入二级分组名称" size="medium">
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align:center">
            <el-button size="small" style="width:110px" @click="groupHandleReset">重置</el-button>
            <el-button size="small" type="primary" style="width:110px" @click="groupHandleConfirm('groupForm')">保存
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- //配置 -->
    <el-dialog :visible.sync="dialogVisible" width="60%" :before-close="handleNewClose" class="recognition-valueLogic">
      <span slot="title" class="dialog-title">
        <span>{{ recognitionRule.title }}</span>
        <span class="sub-title">多字段组合+号隔开</span>
      </span>
      <div class="content-table">
        <el-table :data="tableData" :header-cell-style="styleObj" style="width: 100%">
          <el-table-column type="index" width="90" label="序号" align="center"></el-table-column>
          <el-table-column prop="valueLogic" label="规则" align="center">
            <template #default="scope">
              <el-input v-model="scope.row.valueLogic" type="textarea" :rows="2" :maxlength="100" size="small"
                placeholder="请输入识别规则" v-if="scope.row.status === 'add' || scope.row.status === 'edit'" show-word-limit />
              <span v-else>{{ scope.row.valueLogic }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button @click="editNewClick(scope.row, scope.$index)" type="text" size="small"
                v-if="!scope.row.status">编辑</el-button>
              <el-button @click="handleClick(scope.row)" type="text" size="small"
                v-if="scope.row.status === 'add' || scope.row.status === 'edit'" v-loading="ruleLoading"
                element-loading-spinner="el-icon-loading">保存</el-button>
              <el-button type="text" size="small" @click="deleteRule(scope.row.id, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addRuleItem" size="small">新增</el-button>
      </span>
    </el-dialog>
    <!-- 识别规则弹框 -->
    <!-- <recognition-rule :recognitionRule="recognitionRule" @ruleChange="focusFieldRuleDTOData"></recognition-rule> -->
    <el-dialog v-if="importShow" title="" custom-class="reject-dialog" :visible="true" :close-on-click-modal="false"
      width='60%' :before-close="importClose">
      <div class="group-box">
        <img src="@/assets/images/errorBig.png" class="errorBig" alt="">
        <p class="group-title">导入失败</p>
        <p class="group-text">请核对并修改以下信息后，再重新提交。</p>
        <div class="upload-box">
          <el-upload class="avatar-uploader" action="##" :http-request="uploadServerLog" :show-file-list="false">
          </el-upload>
          <el-button type="primary" size="small" class="uploadBtn" style="margin-left:0px;">重新上传</el-button>
        </div>
        <div class="error-group-box">
          <p class="error-group-box-title">您提交的内容有如下错误：</p>
          <div class="error-group-box-content">
            <ul>
              <li v-for="(item, index) in parseDataList" :key="index">
                <img src="@/assets/images/error-group-icon.png" alt="">
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 文件上传中 -->
    <el-dialog v-if="gressShow" title="批量导入" custom-class="reject-dialog" :visible="true" :close-on-click-modal="false"
      width='40%' :before-close="gressClose">
      <div class="group-box">
        <el-progress :percentage="percentage" :color="customColor"></el-progress>
        <p>文件上传中，请您耐心等待～</p>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisibleNew" width="30%" :before-close="cancelSaveClick">
      <p style="text-align:center;font-size:16px;">未保存前切换分组将清空当前编辑内容</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSaveClick">取消，继续编辑</el-button>
        <el-button type="primary" @click="confinSaveClick">保存，进入下一组</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { resolve } from "path";
import local from "@/utils/local.js";
import axios from "axios";
import Sortable from "sortablejs";
import {
  deleteGroup,
  standardpPage,
  saveGroup,
  getParentGroupDropList,
  manageList,
  getChildGroupList,
  focusFieldExcelDemo,
  focusFieldConfigDetail,
  focusFieldGroup,
  commonQuery,
  focusFieldExcelData,
  getFocusFieldConfigDetail,
  getUnits
} from "../api/index";
import {
  getQueryRuleById,
  saveRule,
  updateRule,
  deletedRule
} from "@/api/diseaseRule.js";
import { changeChapterNo } from "@/api/course";
// import RecognitionRule from '@/components/RecognitionRule/index.vue'
export default {
  // components: { RecognitionRule },
  data () {
    return {
      dataList: [], //原数组
      dataListDelete: [], //被删除的数组
      dataListSame: [], //用来比较数组是否变化的数组
      fieldShow: false, //新增字段是否展示
      subFlag: true,
      delFlag: true,
      curStandardObj: {},
      form: {
        fieldName: "",
        standardFieldName: "",
        groupLevelParentName: "",
        groupLevelChildName: "",
        fieldDescription: "",
        standardFieldId: "", //标准字段id
        // groupId: "", //一级
        // groupParentId: null, //二级
        deleted: 0,
        billDemo: null,
        billDemoUrl: null,
        focusFieldRuleList: [],
        focusFieldPushIntervalList: [
          // {
          //   lower: "",
          //   upper: "",
          //   unit: "",
          //   fourValue: ""
          // }
        ]
        // indexValueListQualitatives: []
      },
      groupForm: {
        configType: "department",
        groupLevel: 1,
        groupParentId: null,
        groupName: null
      },
      formRules: {
        fieldName: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        standardFieldId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        // fileNameObj: [
        //   {
        //     required: true,
        //     message: "此项为必填项",
        //     trigger: ["change", "blur"]
        //   }
        // ],
        groupId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        groupParentId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ]
      },
      groupFormRules: {
        groupLevel: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        groupName: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        groupParentId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ]
      },
      groupShow: false,
      managementGroupShow: false,
      searchParams: {
        current: 1,
        size: 10
      },
      total: 0,
      standardList: [], //重点指标字段下拉数组
      dataListGroup: [], //分组列表
      levelOneGroupList: [], //一级分组下拉框中的数组
      levelTwoGroupList: [], //二级分组下拉框中的数组
      editFlagStatus: true, //是否编辑字段
      dataIndex: 0, //编辑重点指标字段的下标
      inspectPageNum: 0,
      inspectPage: {
        current: 1,
        size: 20
      },
      likeName: "",
      dataListDrag: [], //拖拽之后的数组
      menu: [], //左侧树组件菜单
      currentKey: "1565177687634194434",
      currentKeyNew: "",
      treeList: "",
      currentData: {
        id: "1565177687634194434",
        label: "无分组",
        name: "无分组",
        children: []
      },
      currentDataNew: {
        id: "1565177687634194434",
        label: "无分组",
        name: "无分组",
        children: []
      },
      VUE_APP_WECHATBASE_URL: "/api/dsicm-contact-platform/feign/file/upload", //上传图片的接口路径
      dataListDeleteNew: [], //所有取消字段的数组
      inspectPage: {
        current: 1,
        size: 10
      },
      inspectPageNum: 0,
      videoValidation: false,
      treeId: null,
      menuNo: [
        {
          id: "1565177687634194434",
          label: "无分组",
          name: "无分组",
          children: []
        }
      ],
      imgPath: process.env.VUE_APP_OSS_URL,
      defaultProps: {
        label: "label",
        children: "children",
        disabled: true
        // disabled: function(data, node) {
        //   if (data.label === '自定义分组') {
        //     return false
        //   }
        // }
      },
      defaultPropsNew: {
        label: "label",
        children: "children",
        disabled: true
        // disabled: function(data, node) {
        //   if (data.label === '自定义分组') {
        //     return false
        //   }
        // }
      },
      recognitionRule: {
        visible: true,
        title: "识别规则配置",
        id: ""
      },
      dialogVisible: false,
      tableData: [],
      styleObj: {
        background: "#FAFAFA",
        fontWeight: "bold",
        color: "#333333",
        fontSize: "14px"
      },
      groupId: null,
      groupParentId: null,
      configParentId: null,
      Authorization: localStorage.getItem("Authorization"),
      currentDataId: null,
      importShow: false,
      gressShow: false,
      parseDataList: [],
      percentage: 10,
      customColor: "#409eff",
      curren: "无分组",
      currentKeyFlag: true,
      fileNameObj: {},
      moveFlag: true, //false 不让拖动  true  //让拖动
      ruleLoading: false,
      standardFieldId: null, //编辑回显重点字段的
      choseBtnIndex: null, //当前列表的下标
      choseBtnIndexDelete: null, //当前列表的下标
      dialogVisibleNew: false,
      currentVisibleNew: {}, //点击树节点的对象
      resultProperty: 2,
      unitList: [],
      referencesList: []
    };
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    oldList: {
      //重点关注指标列表
      type: Array,
      default: () => [],
      require: true
    },
    allOldList: {
      //重点关注指标列表取消重点字段之后的数组
      type: Array,
      default: () => [],
      require: true
    },
    diseaseId: {
      //病种id
      type: String,
      default: () => "",
      require: true
    },
    openDepartmentId: {
      //科室id
      type: String,
      default: () => "",
      require: true
    },
    openDepartmentParentId: {
      //科室id
      type: String,
      default: () => "",
      require: true
    },
    teamId: {
      //团队id
      type: String,
      default: () => "",
      require: true
    },
    hospitalId: {
      //医院id
      type: String,
      default: () => "",
      require: true
    },
    statusType: {
      //
      type: String,
      default: () => "department",
      require: true
    },
    bigStatus: {
      type: Boolean,
      default: false
    },
    diseaseName: {
      //
      type: String,
      default: () => null,
      require: true
    }
  },
  created () {
    this.$nextTick(() => {
      this.rowDrop();
      this.manageListRequest();
      this.commonQueryRequest();
    });
  },
  mounted () {
    this.standardpPageRequest();
    // this.getFocusFieldConfigDetailRequest();
    this.fetchTreeData();
  },
  watch: {
    oldList: {
      handler (arr) {
        if (arr) {
          // this.dataList = arr;
        }
      },
      deep: true,
      immediate: true
    },
    allOldList: {
      handler (arr) {
        if (arr) {
          // this.dataListDelete = JSON.parse(JSON.stringify(arr));
        }
      },
      deep: true,
      immediate: true
    },
    diseaseId (newVal, oldVal) {
      if (newVal) {
        this.dataListDelete = [];
        this.dataList = [];
        this.dataListSame = [];
        this.groupId = null;
        this.currentKeyFlag = false;
        this.manageListRequest();
        this.standardpPageRequest();
        // this.getFocusFieldConfigDetailRequest();
        // this.commonQueryRequest();

        this.currentDataNew = {
          id: "1565177687634194434",
          label: "无分组",
          name: "无分组",
          children: []
        };
        this.currentData = {
          id: "1565177687634194434",
          label: "无分组",
          name: "无分组",
          children: []
        };
        this.currentKey = "1565177687634194434";

        setTimeout(() => {
          this.currentKeyFlag = true;
        }, 100);
        this.commonQueryRequest();
      }
    },
    bigStatus (newVal, oldVal) {
      console.log(newVal, "newVal");
      if (newVal) {
        this.rowDrop();
        this.defaultProps = {
          label: "label",
          children: "children",
          disabled: true //禁用方法
        };
      }
    }
  },
  methods: {
    addFieldClick () {
      if (!this.diseaseId) {
        this.$message.error("请选择病种！");
        return;
      }
      if (!this.hospitalId && this.statusType != "platform") {
        this.$message.error("请选择机构！");
        return;
      }
      if (!this.openDepartmentId && this.statusType != "platform") {
        this.$message.error("请选择科室！");
        return;
      }
      this.standardList = [];
      this.inspectInput = "";
      this.standardpPageRequest(1, this.inspectInput, "").then(res => {
        this.handleDisabled();
      });
      this.levelTwoGroupList = [];
      this.tableData = [];
      //新增字段
      // this.getParentGroupDropListRequest();
      // this.manageListRequest();
      this.form = {
        fieldName: "",
        standardFieldName: "",
        groupLevelParentName: "",
        groupLevelChildName: "",
        fieldDescription: "",
        standardFieldId: "", //标准字段id
        groupId: "", //一级
        groupParentId: null, //二级
        deleted: 0,
        focusFieldRuleList: [],
        focusFieldPushIntervalList: [
          // {
          //   lower: "",
          //   upper: "",
          //   unit: "",
          //   fourValue: ""
          // }
        ]
        // indexValueListQuantitatives: []
      };
      this.resultProperty = 2;
      this.fieldShow = true;
      this.editFlagStatus = false;
    },
    handleDisabled (val) {
      this.standardList.map(item => {
        item.disabled = false;
      });
      let haveId = [];
      this.dataList.map(item => {
        if (item.standardFieldId != val) {
          //当前编辑的可选
          haveId.push(item.standardFieldId);
        }
      });
      haveId.map(item => {
        this.standardList.map(child => {
          if (item == child.id && child.regionId == 4) {
            child.disabled = true;
          }
        });
      });
    },
    addGroupingClick () {
      this.groupShow = true;
    },
    find (str, cha, num) {
      var x = str.indexOf(cha);
      for (var i = 0; i < num; i++) {
        x = str.indexOf(cha, x + 1);
      }
      return x;
    },
    editClick (item, index) {
      console.log(item, "item");

      this.curStandardObj = item;
      this.choseBtnIndex = this.dataList.findIndex(item => {
        return item.idNew == this.curStandardObj.idNew;
      });
      this.choseBtnIndexDelete = this.dataListDelete.findIndex(item => {
        return item.idNew == this.curStandardObj.idNew;
      });

      this.dataIndex = index;
      this.form = {};
      let firstOrderid = null;
      let parentFirstOrderid = null;
      this.standardList = [];
      this.standardFieldId = item.standardFieldId;
      // let indexfirst = this.find(item.standardFieldName, "-", 1);
      // let indexsecond = this.find(item.standardFieldName, "-", 2);
      // if (indexfirst == -1) {
      //   this.inspectInput = item.standardFieldName.charAt(0);
      // } else {
      //   this.inspectInput = item.standardFieldName.substring(
      //     indexfirst + 1,
      //     indexsecond
      //   );
      // }
      this.inspectInput = "";
      // let standardFieldName = item.standardFieldName.charAt(0);
      // return false;
      this.standardpPageRequest(
        1,
        this.inspectInput,
        this.standardFieldId
      ).then(res => {
        this.handleDisabled(item.standardFieldId);

        this.form = JSON.parse(JSON.stringify(item));
        this.form.standardFieldName = item.contactStandardFieldName;
        // this.fileNameObj.id = item.standardFieldId;
        // this.fileNameObj.name = item.name;

        // this.$set(this.fileNameObj,'id',item.standardFieldId);
        // this.$set(this.fileNameObj,'name',item.standardFieldId);
        let itemObj = JSON.parse(JSON.stringify(item));
        if (!itemObj.billDemo) {
          this.$set(this.form, "billDemoUrl", "");
        } else {
          this.$set(this.form, "billDemoUrl", this.imgPath + itemObj.billDemo);
        }
        console.log(res, "resss");
        this.getUnitsRequest();
        if (res && res.records && res.records.length > 0) {
          this.resultProperty = res.records[0].resultProperty;
          // this.getUnitsRequest();
        }

        // this.form.billDemoUrl = item.billDemoUrl;
      });
      this.fieldShow = true;
      this.editFlagStatus = true;
    },
    confimClick (item, index) {
      this.$refs[index].doClose();
      // item.removeVisible = false;
      this.dataList.splice(index, 1);
      // this.$refs['scoperef'].doClose();
      // this.dataList[item.itemIndex].deleted = true;
      // return false;
      if (!item.id && !item.deleted) {
        this.dataListDelete.splice(item.itemIndex, 1);
      } else {
        this.dataListDelete[item.itemIndex].deleted = true;
        this.dataListDeleteNew.push(this.dataListDelete[item.itemIndex]);
      }
      this.dataList = this.dataList.map((item, index) => {
        return {
          ...item,
          standardFieldName: item.contactStandardFieldName
        };
      });
      this.dataListDelete = this.dataListDelete.map((item, index) => {
        return {
          ...item,
          standardFieldName: item.contactStandardFieldName
        };
      });
      this.$emit("confimClick", this.dataListDelete);
    },
    handleCurClose () {
      //新增字段弹窗关闭
      this.fieldShow = false;
      this.editFlagStatus = false;
      // this.levelTwoGroupList = [];
    },
    // handleNewClose() {
    //   this.dialogVisible = false;
    // },
    handleReset (form) {
      this.form = {
        fieldName: "",
        standardFieldName: "",
        groupLevelParentName: "",
        groupLevelChildName: "",
        fieldDescription: "",
        standardFieldId: "", //标准字段id
        groupId: "", //一级
        groupParentId: null, //二级
        deleted: true,
        focusFieldRuleList: [],
        focusFieldPushIntervalList: []
      };
      this.resultProperty = null;
      this.levelTwoGroupList = [];
      this.$refs.form.resetFields();
    },
    handleConfirm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let flag = true;
          let focusFieldPushIntervalList = [];
          if (this.resultProperty == 1) {
            if (this.form.focusFieldPushIntervalList.length > 0) {
              this.form.focusFieldPushIntervalList.forEach((item, index) => {
                if (item.lower > 1000 || item.upper > 1000) {
                  flag = false;
                }
                console.log(flag, "flag1");
                if (
                  (item.lower != "" && item.upper != "" && item.unit != "") ||
                  (item.lower == "" && item.upper == "" && item.unit == "")
                ) {
                } else {
                  flag = false;
                }
                if (Number(item.lower) > Number(item.upper)) {
                  flag = false;
                }
                console.log(flag, "flag3");
              });

              focusFieldPushIntervalList = this.form.focusFieldPushIntervalList.filter(
                function (item) {
                  return (
                    item.lower != "" && item.upper != "" && item.unit != ""
                  );
                }
              );
              console.log(
                this.form.focusFieldPushIntervalList,
                "this.form.focusFieldPushIntervalList111"
              );
            }
          }
          if (this.resultProperty == 0) {
            focusFieldPushIntervalList = this.form.focusFieldPushIntervalList;
          }
          if (!flag) {
            this.$message.error("请填写正确的指标区间");
            return false;
          }

          console.log(
            this.form.focusFieldPushIntervalList,
            "this.form.focusFieldPushIntervalList222"
          );

          if (this.editFlagStatus) {
            this.fieldShow = false;
            let obj = this.form;
            obj.focusFieldPushIntervalList = focusFieldPushIntervalList;
            if (!this.currentData.groupParentId) {
              obj.groupParentId = "-1";
            } else {
              let firstOrderid = this.currentData.id;
              let parentFirstOrderid = this.currentData.groupParentId;
              obj.groupId = firstOrderid;
              obj.groupParentId = parentFirstOrderid;
            }
            if (
              this.currentData.name == "无分组" ||
              this.currentData.name == "自定义分组"
            ) {
              delete obj.groupParentId;
            }
            obj.deleted = false;
            obj.editFlag = true;
            obj.contactStandardFieldName = this.form.standardFieldName;
            this.dataList = JSON.parse(JSON.stringify(this.dataList));
            this.dataListDelete = JSON.parse(
              JSON.stringify(this.dataListDelete)
            );
            // this.dataList.map((val, i) => {
            //   if (
            //     val.configType == this.curStandardObj.configType &&
            //     val.id == this.curStandardObj.id
            //   ) {
            //     this.dataList[i] = obj;
            //   }
            // });
            // this.dataListDelete.map((val, i) => {
            //   if (
            //     val.configType == this.curStandardObj.configType &&
            //     val.id == this.curStandardObj.id &&
            //     !val.deleted
            //   ) {
            //     this.dataListDelete[i] = obj;
            //   }
            // });
            this.dataList[this.choseBtnIndex] = obj;
            this.dataListDelete[this.choseBtnIndexDelete] = obj;
            this.dataList = this.dataList.map((item, index) => {
              return {
                ...item,
                standardFieldName: item.contactStandardFieldName
              };
            });
            this.dataListDelete = this.dataListDelete.map((item, index) => {
              return {
                ...item,
                standardFieldName: item.contactStandardFieldName
              };
            });
            this.$emit("confimClick", this.dataListDelete);
            this.$forceUpdate();
          } else {
            let obj = this.form;
            obj.focusFieldPushIntervalList = focusFieldPushIntervalList;
            let flag = true;
            for (let i = 0; i < this.dataListDelete.length; i++) {
              if (this.dataListDelete[i].fieldName == this.form.fieldName) {
                flag = false;
              }
            }
            if (!flag) {
              this.$message.error("字段名称不能重复");
              return false;
            }
            this.fieldShow = false;
            if (this.currentData.groupParentId) {
              let firstOrderid = this.currentData.id;
              let parentFirstOrderid = this.currentData.groupParentId;
              obj.groupId = firstOrderid;
              obj.groupParentId = parentFirstOrderid;
              obj.groupLevelChildName = this.currentData.groupName;
              obj.groupLevelParentName = this.currentData.groupParentName;
            } else {
              obj.groupParentId = "-1";
            }
            if (
              this.currentData.name == "无分组" ||
              this.currentData.name == "自定义分组"
            ) {
              delete obj.groupParentId;
            }
            // department platform
            if (this.statusType == "department") {
              obj.source = "科室";
            } else if (this.statusType == "platform") {
              // obj.source = ''
            } else {
              obj.source = "团队添加";
            }
            obj.contactStandardFieldName = this.form.standardFieldName;
            obj.idNew = this.idFun();
            obj.removeVisible = false;
            obj.deleted = false;
            obj.itemIndex = this.dataListDelete.length;
            obj.editFlag = true;
            obj.configType = this.statusType;
            this.dataList = this.dataList.concat(obj);
            this.dataListDelete = this.dataListDelete.concat(obj);
            this.moveFlag = false;
            this.dataList = this.dataList.map((item, index) => {
              return {
                ...item,
                standardFieldName: item.contactStandardFieldName
              };
            });
            this.dataListDelete = this.dataListDelete.map((item, index) => {
              return {
                ...item,
                standardFieldName: item.contactStandardFieldName
              };
            });
            console.log(this.dataList, "this.dataList");
            this.$emit("confimClick", this.dataListDelete);
            this.$forceUpdate();
          }
        } else {
        }
      });
    },
    selectMethod (e) {
      let arr = this.standardList.filter(item => {
        return item.id == e;
      });
      console.log(arr, "arr");
      if (arr.length > 0) {
        // this.fileNameObj = arr[0];
        this.form.standardFieldName = arr[0].contactStandardFieldName;
        this.resultProperty = arr[0].resultProperty;
        this.form.focusFieldPushIntervalList = [];
        this.getUnitsRequest(); //调用了获取参考值单位的接口
      }

      // this.queryDepartment(); //调用了获取参考值单位的接口
    },
    groupChange (e) {
      if (this.currentDataNew.name != "无分组") {
        if (e == 1) {
          if (this.currentDataNew.groupLevel == 1) {
          } else if (this.currentDataNew.groupLevel == 2) {
            if (this.currentDataNew.groupParentId == "-1") {
              this.groupForm.groupParentId = this.currentDataNew.groupParentId;
            }
          }
          this.groupForm.groupName = null;
        } else if (e == 2) {
          if (this.currentDataNew.groupLevel == 1) {
            if (this.currentDataNew.groupParentId == "-1") {
              this.groupForm.groupParentId = this.currentDataNew.id;
            } else {
              this.groupForm.groupParentId = this.currentDataNew.groupParentId;
            }
          } else if (this.currentDataNew.groupLevel == 2) {
            if (this.currentDataNew.groupParentId == "-1") {
              this.groupForm.groupParentId = this.currentDataNew.groupParentId;
            }
          }
          this.groupForm.groupName = null;
        }
      } else {
        this.$set(this.groupForm, "groupParentId", "");
        this.$set(this.groupForm, "groupName", "");
      }

      // this.groupForm.groupName = null;
      // this.getParentGroupDropListRequest();
      // this.manageListRequest();
    },
    groupHandleClose () {
      this.groupShow = false;
    },
    groupHandleReset (groupForm) {
      this.currentDataNew = {
        id: "1565177687634194434",
        label: "无分组",
        name: "无分组",
        children: []
      };
      this.groupForm.groupLevel = 1;
      this.$set(this.groupForm, "groupParentId", "");
      this.$set(this.groupForm, "groupName", "");
      // this.$refs.groupForm.resetFields();
      this.$forceUpdate();
    },
    groupHandleConfirm (groupForm) {
      //添加分组
      //  科室  hospitalId  openDepartmentId   一级：    groupType   groupLevel    groupParentId-1    groupName

      //  二级： groupType   groupLevel    groupParentId    groupName

      //  团队：hospitalId  openDepartmentId teamId（必须）

      this.$refs[groupForm].validate(valid => {
        if (valid) {
          let obj = {
            groupType: this.statusType,
            openDepartmentId: this.openDepartmentId,
            openDepartmentParentId: this.openDepartmentParentId,
            hospitalId: this.hospitalId,
            diseaseId: this.diseaseId,
            groupName: this.groupForm.groupName,
            deleted: 1,
            groupLevel: this.groupForm.groupLevel
          };
          if (this.statusType == "department") {
            if (this.groupForm.groupLevel == 1) {
              obj.groupParentId = -1;
            } else {
              obj.groupParentId = this.groupForm.groupParentId;
            }
          } else {
            if (this.groupForm.groupLevel == 1) {
              obj.teamId = this.teamId;
              obj.groupParentId = -1;
            } else {
              obj.teamId = this.teamId;
              obj.groupParentId = this.groupForm.groupParentId;
            }
          }
          if (!this.subFlag) {
            return;
          }
          this.subFlag = false;
          saveGroup(obj)
            .then(res => {
              if (res.code == 0) {
                this.$forceUpdate();
                this.managementGroupShow = false;
                this.subFlag = true;
                this.groupForm = {
                  configType: this.statusType,
                  groupLevel: 1,
                  groupParentId: null,
                  groupName: null
                };
                this.$refs.groupForm.resetFields();
                this.searchParams.current = 1;
                this.currentKey = res.data;
                this.fetchTreeData();
                this.manageListRequest();
              }
            })
            .catch(err => {
              this.subFlag = true;
            });
        } else {
          return false;
        }
      });
    },
    managementGroupClose () {
      this.managementGroupShow = false;
      this.groupShow = false;
      this.groupForm = {
        configType: this.statusType,
        groupLevel: 1,
        groupParentId: null,
        groupName: null
      };
    },
    managementGroupClick () {
      if (!this.diseaseId) {
        this.$message.error("请选择病种！");
        return;
      }
      if (!this.hospitalId && this.statusType != "platform") {
        this.$message.error("请选择机构！");
        return;
      }
      if (!this.openDepartmentId && this.statusType != "platform") {
        this.$message.error("请选择科室！");
        return;
      }
      // this.manageListRequest();
      // this.getParentGroupDropListRequest();
      if (
        this.currentDataNew.name == "无分组" ||
        this.currentDataNew.name == "自定义分组"
      ) {
        this.groupForm.groupLevel = 1;
      } else {
        // this.groupForm.groupLevel = this.currentData.groupLevel;
        this.groupForm.groupLevel = 2;

        if (this.currentDataNew.groupLevel == 1) {
          if (this.currentDataNew.groupParentId == "-1") {
            this.groupForm.groupParentId = this.currentDataNew.id;
          } else {
            this.groupForm.groupParentId = this.currentDataNew.groupParentId;
          }
          this.groupForm.groupName = null;
        } else if (this.currentDataNew.groupLevel == 2) {
          if (this.currentDataNew.groupParentId == "-1") {
            this.groupForm.groupParentId = this.currentDataNew.id;
          } else {
            this.groupForm.groupParentId = this.currentDataNew.groupParentId;
          }
        }
      }
      this.managementGroupShow = true;
    },
    handleSizeChange (val) {
      this.searchParams.size = val;
      this.manageListRequest();
    },
    handleCurrentChange (val) {
      this.searchParams.current = val;
      this.manageListRequest();
    },
    deleteClick () {
      if (this.currentData.children && this.currentData.children.length > 0) {
        this.$refs[`group0`].doClose();
        this.$message.error("请先删除二级分组");
        return false;
      }
      if (this.currentData.canDeleted == false) {
        this.$refs[`group0`].doClose();
        this.$message.error("当前分组不能删除");
        return false;
      }
      //删除分组
      let delFirstId = null;
      let delSecondId = null;
      //存在二级分组 找列表中是否有二级分组
      if (this.currentData.levelTwoGroupId) {
        delSecondId = this.currentData.levelTwoGroupId;
      } else {
        delFirstId = this.currentData.levelOneGroupId;
      }
      // let obj = { groupType: this.statusType, groupId: item.groupId };
      let obj = { groupType: this.statusType, groupId: this.currentData.id };
      deleteGroup(obj)
        .then(res => {
          if (res.code == 0) {
            this.$refs[`group0`].doClose();
            if (this.dataListGroup.length <= 1) {
              if (this.searchParams.current > 1) {
                this.searchParams.current = this.searchParams.current - 1;
              } else {
                this.searchParams.current = 1;
              }
            }
            //处理当前页面展示数据
            let delArr = [];
            this.dataList.map((child, eq) => {
              if (child.groupParentId != "-1" && child.groupId == delSecondId) {
                delArr.push(eq);
              }
              if (child.groupParentId == "-1" && child.groupId == delFirstId) {
                delArr.push(eq);
              }
            });
            if (delArr.length > 0) {
              for (let i = delArr.length - 1; i >= 0; i--) {
                this.dataList.splice(delArr[i], 1);
              }
            }
            //传入后端结果
            let delArrDelete = [];
            this.dataListDelete.map((child, eq) => {
              if (
                child.groupParentId != "-1" &&
                child.groupId == delSecondId &&
                !item.deleted
              ) {
                delArrDelete.push(eq);
              }
              if (
                child.groupParentId == "-1" &&
                child.groupId == delFirstId &&
                !item.deleted
              ) {
                delArrDelete.push(eq);
              }
            });
            if (delArrDelete.length > 0) {
              for (let i = delArrDelete.length - 1; i >= 0; i--) {
                this.dataListDelete.splice(delArrDelete[i], 1);
              }
            }
            this.dataList = this.dataList.map((item, index) => {
              return {
                ...item,
                standardFieldName: item.contactStandardFieldName
              };
            });
            this.dataListDelete = this.dataListDelete.map((item, index) => {
              return {
                ...item,
                standardFieldName: item.contactStandardFieldName
              };
            });
            this.$emit("confimClick", this.dataListDelete);
            this.currentData = {
              id: "1565177687634194434",
              label: "无分组",
              name: "无分组",
              children: []
            };
            this.currentDataNew = {
              id: "1565177687634194434",
              label: "无分组",
              name: "无分组",
              children: []
            };
            this.currentKey = "1565177687634194434";
            this.$nextTick(() => {
              this.$refs.treeRefNo.setCurrentKey(this.currentKey);
            });
            this.manageListRequest();
            this.commonQueryRequest();
            this.groupForm.groupParentId = "";
            this.groupForm.groupName = "";
            this.$refs.groupForm.resetFields();
            // this.getParentGroupDropListRequest();

            this.$forceUpdate();
            this.$message.success("删除成功");
            setTimeout(() => {
              this.delFlag = true;
            }, 300);
          }
        })
        .catch(err => {
          this.delFlag = true;
        });

      return;
    },
    loadmoreInspect () {
      this.inspectPage.current++;
      if (this.inspectPage.current > this.inspectPageNum) {
        return;
      }
      this.standardFieldId = null;
      this.standardpPageRequest(
        this.inspectPage.current,
        this.inspectInput,
        this.standardFieldId
      );
    },
    selectFocus () {
      this.standardList = [];
      let current = 1;
      let searchCondition = "";
      let standardFieldId = null;
      this.inspectInput = "";
      this.standardpPageRequest(current, searchCondition, standardFieldId);
    },
    standardpPageRequest (current, searchCondition, standardFieldId) {
      if (!current) {
        current = 1;
      }
      //重点字段下拉
      let obj = {
        current: current,
        size: 10,
        diseaseId: this.diseaseId,
        likeName: searchCondition,
        standardFieldId: standardFieldId,
        searchHospitalId: this.hospitalId,
        searchDoctorTeamId: this.teamId,
        searchConfigType: this.statusType,
        searchOpenDepartmentId: this.openDepartmentId,
        searchOpenDepartmentParentId: this.openDepartmentParentId
      };
      return new Promise((resolve, reject) => {
        standardpPage(obj).then(res => {
          if (res.code == 0) {
            if (res.data) {
              if (res.data.records && res.data.records.length > 0) {
                let arr = res.data.records.map(item => {
                  return {
                    ...item,
                    disabled: !item.checked,
                    mergeName:
                      item.contactStandardFieldName +
                      this.returnNameFirst(item.standFiledUseCount)
                  };
                });
                // arr
                let haveId = [];
                this.dataList.map(item => {
                  arr.map(child => {
                    if (item.standardFieldId == child.id) {
                      haveId.push(child);
                    }
                  });
                });
                haveId.map(item => {
                  arr.map(child => {
                    if (item.id == child.id && child.regionId == 4) {
                      child.disabled = true;
                    }
                  });
                });
                this.standardList = this.standardList.concat(arr);
                this.inspectPageNum = res.data.pages;
              }
              resolve(res.data);
            } else {
              reject(res);
            }
          }
        });
      });
    },
    filtSetClick (item, index) {
      this.$set(item, "removeVisible", true);
      this.$set(this.dataList[index], "removeVisible", true);
      this.dataList[index].removeVisible = true;
      this.$forceUpdate();
    },
    returnNameFirst (name) {
      let fieldName = "";
      fieldName = name == null || name == "" ? "" : "-" + name;
      return fieldName;
    },
    returnNameSecond (name) {
      let fieldName = "";
      fieldName = name == null || name == "" ? "" : name + "-";
      return fieldName;
    },
    returnNameThird (name) {
      let fieldName = "";
      fieldName = name == null || name == "" ? "" : name + "-";
      return fieldName;
    },
    remoteInspectItemMethod (query) {
      this.standardList = [];
      this.inspectPage.current = 1;
      if (query !== "") {
        this.inspectInput = query;
        this.standardpPageRequest(1, query, "");
      } else {
        // this.inspectionList = [];
        this.inspectInput = query;
        this.standardpPageRequest(1, query, "");
      }
    },
    // getParentGroupDropListRequest() {
    //   //获取一级分组
    //   let obj = {
    //     current: 1,
    //     size: 100,
    //     groupType: this.statusType,
    //     openDepartmentId: this.openDepartmentId,
    //     diseaseId: this.diseaseId,
    //     hospitalId: this.hospitalId
    //   };
    //   if (this.statusType == "team") {
    //     obj.teamId = this.teamId;
    //   }
    //   return new Promise((resolve, reject) => {
    //     getParentGroupDropList(obj).then(res => {
    //       if (res.code == 0) {
    //         if (res.data && res.data.length > 0) {
    //           res.data.map(item => {
    //             item.mergeGroupName =
    //               this.handelBelong(item.groupType) + "-" + item.groupName;
    //           });
    //           this.levelOneGroupList = res.data;
    //         } else {
    //           this.levelOneGroupList = [];
    //         }
    //         resolve(res.data);
    //       } else {
    //         reject(res);
    //       }
    //     });
    //   });
    // },
    handelBelong (type) {
      if (type == "department") {
        return "科室";
      } else if (type == "platform") {
        return "平台";
      } else {
        return "团队";
      }
    },
    secondOrderChange (e) {
      this.form.groupParentId = e;
      let arr = this.levelTwoGroupList.filter(item => {
        return item.id == e;
      });

      // standardFieldId standardFieldName
      if (arr.length > 0) {
        this.form.groupLevelChildName = arr[0].groupName;
      }
    },
    // getFocusFieldConfigDetailRequest() {
    //   //为了获取configParentld
    //   let obj = {};
    //   if (this.statusType == "department") {
    //     // return "科室";
    //     // 机构ID+科室ID+病种ID+类型
    //     obj = {
    //       diseaseId: this.diseaseId,
    //       hospitalId: this.hospitalId,
    //       configType: this.statusType,
    //       openDepartmentId: this.openDepartmentId,
    //       openDepartmentParentId: this.openDepartmentParentId,
    //       diseaseName: this.diseaseName
    //     };
    //   } else if (this.statusType == "platform") {
    //     // return "平台";
    //     // 病种ID+类型
    //     obj = {
    //       diseaseId: this.diseaseId,
    //       configType: this.statusType,
    //       diseaseName: this.diseaseName
    //     };
    //   } else {
    //     // return "团队";
    //     // 团队ID+病种ID+类型
    //     obj = {
    //       diseaseId: this.diseaseId,
    //       hospitalId: this.hospitalId,
    //       teamId: this.teamId,
    //       configType: this.statusType,
    //       openDepartmentId: this.openDepartmentId,
    //       openDepartmentParentId: this.openDepartmentParentId,
    //       diseaseName: this.diseaseName
    //     };
    //   }
    //   getFocusFieldConfigDetail(obj).then(res => {
    //     if (res.code == 0) {
    //       this.configParentId = res.data.id;
    //     }
    //   });
    // },
    manageListRequest () {
      //获取管理分组的列表
      if (this.diseaseId == '') {
        return false;
      }
      let obj = {
        diseaseId: this.diseaseId,
        hospitalId: this.hospitalId,
        groupType: this.statusType,
        hospitalId: this.hospitalId,
        openDepartmentId: this.openDepartmentId,
        diseaseId: this.diseaseId,
        keyWord: "",
        groupId: ""
      };
      if (this.statusType == "team") {
        obj.teamId = this.teamId;
      }
      manageList(obj).then(res => {
        if (res.code == 0) {
          if (res.data && res.data.length > 0) {
            this.dataListGroup = res.data;

            let list = [];
            let arr = [];
            let obj = {
              // id: "1565177687634194434",
              id: "1565177687634194435",
              label: "自定义分组",
              name: "自定义分组",
              children: []
            };
            // obj.children = obj.subChapters;
            // obj.label = obj.name;
            // arr[0] = obj;
            // list = res.data.records;
            obj.children = res.data;
            arr[0] = obj;
            list = arr;
            let toolFun = obj => {
              obj.forEach((item, index) => {
                item.children = item.childGroup ? item.childGroup : [];
                item.label =
                  index +
                  1 +
                  "_" +
                  this.handelBelong(item.groupType) +
                  "_" +
                  item.groupName;
                item.groupNameNew =
                  this.handelBelong(item.groupType) + "_" + item.groupName;
                item.chapterNo = index + 1;
                if (item.children && item.children.length > 0) {
                  item.children.forEach((el, i) => {
                    el.children = el.childGroup;
                    el.label =
                      index +
                      1 +
                      "." +
                      (i + 1) +
                      "_" +
                      this.handelBelong(el.groupType) +
                      "_" +
                      el.groupName;
                    el.groupNameNew =
                      this.handelBelong(el.groupType) + "_" + el.groupName;
                    item.chapterNo = index + 1 + "." + (i + 1);
                    if (el.children && el.children.length > 0) {
                      el.children.forEach((elItem, iItem) => {
                        elItem.children = elItem.childGroup;
                        elItem.label =
                          i +
                          1 +
                          "." +
                          (iItem + 1) +
                          "_" +
                          this.handelBelong(elItem.groupType) +
                          "_" +
                          elItem.groupName;
                        elItem.chapterNo = i + 1 + "." + (iItem + 1);
                        elItem.groupNameNew =
                          this.handelBelong(elItem.groupType) +
                          "_" +
                          elItem.groupName;
                      });
                      toolFun(el.children);
                    }
                  });
                }
              });
            };
            toolFun(list[0].children);
            this.levelOneGroupList = list[0].children;
            this.menu = list;

            this.currentKeyNew = this.currentData.id;
            this.$nextTick(() => {
              this.$refs.treeRef.setCurrentKey(this.currentKeyNew);
            });
          } else {
            let list = [];
            let arr = [];
            let obj = {
              id: "1565177687634194435",
              label: "自定义分组",
              name: "自定义分组",
              children: []
            };
            arr[0] = obj;
            list = arr;
            this.levelOneGroupList = [];
            this.menu = list;
          }
        }
      });
    },
    handleFold (obj, flag) {
      if (obj.childGroup && obj.childGroup.length > 0) {
        if (obj.fold === undefined) {
          this.$set(obj, "fold", flag);
        } else {
          obj.fold = flag;
        }
      }
    },
    fn (arr) {
      return arr.filter((item, index, arr) => arr.indexOf(item) === index);
    },
    firstOrderChange (e) {
      this.getChildGroupListRequest(e);
      let arr = this.levelOneGroupList.filter(item => {
        return item.id == e;
      });
      if (arr.length > 0) {
        this.form.groupLevelParentName = arr[0].groupName;
      }
      this.form.groupParentId = null;
      this.form.groupLevelChildName = "";
    },
    levelOneGroupChange (e) {
      this.groupForm.groupParentId = e;

      // let index = this.levelOneGroupList.findIndex(item => {return item.id == this.groupForm.groupParentId})
    },
    getChildGroupListRequest (groupParentId) {
      //二级下拉
      let obj = {
        current: 1,
        size: 100,
        groupType: this.statusType,
        teamId: this.teamId,
        openDepartmentId: this.openDepartmentId,
        diseaseId: this.diseaseId,
        hospitalId: this.hospitalId,
        groupId: groupParentId
      };
      if (this.statusType == "team") {
        obj.teamId = this.teamId;
      }
      return new Promise((resolve, reject) => {
        getChildGroupList(obj).then(res => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              res.data.map(item => {
                item.mergeGroupName =
                  this.handelBelong(item.groupType) + "-" + item.groupName;
              });
              this.levelTwoGroupList = res.data;
              resolve(true);
              this.$forceUpdate();
            } else {
              reject(false);
              this.levelTwoGroupList = [];
            }
          } else {
            reject(false);
          }
        });
      });
    },
    doClose (index, flag) {
      if (flag) {
        this.$refs[`group${index}`].doClose();
      } else {
        this.$refs[index].doClose();
      }
    },
    doCloseNew (index, flag) {
      // this.$refs[index].doClose();
      // this.$refs[index][0].doClose();
      this.$refs[`popover-${index}`].doClose();
    },
    titleFun (num) {
      let name = "";
      if (num == 0) {
        name = "序号";
      } else if (num == 1) {
        name = "一级分组";
      } else if (num == 1) {
        name = "二级分组";
      } else if (num == 1) {
        name = "备注";
      } else if (num == 1) {
        name = "字段名称";
      } else if (num == 1) {
        name = "对应标准字段";
      } else if (num == 1) {
        name = "操作";
      }
      return name;
    },
    //行-拖拽
    rowDrop () {
      const tbody = document.querySelector(".el-table-box tbody");
      const _this = this;
      if (!this.bigStatus) {
        return false;
      }
      Sortable.create(tbody, {
        filter: ".not-sort", // 过滤.not-sort的元素
        onMove: (evt, originalEvent) => {
          if (!_this.dataList[evt.dragged.rowIndex].id) {
            // _this.$message.error("当前数据不能拖动");
            // throw false
            return false;
          }
          if (_this.dataList[evt.dragged.rowIndex].canDeleted == false) {
            // _this.$message.error("当前数据不能拖动");
            // throw false
            return false;
          }
        },
        onEnd ({ newIndex, oldIndex }) {
          let moveLocation = "";
          if (newIndex > oldIndex) {
            //向下拖拽
            moveLocation = "down";
          } else {
            //向上拖拽
            moveLocation = "up";
          }
          const currRow = _this.dataList.splice(oldIndex, 1)[0];
          _this.dataList.splice(newIndex, 0, currRow);
          //   拖动后获取newIdex
          let arr = Array.from(_this.dataList);
          _this.dataListDrag = arr.map((item, index) => {
            return {
              ...item,
              id: item.id,
              dictSort: index,
              itemIndex: index
            };
          });
          let listDrag = [];
          _this.dataListDrag.forEach((item, index) => {
            if (item.id) {
              listDrag.push(item);
            }
          });
          // let arrNew = _this.dataListDrag.concat(_this.dataListDeleteNew);
          // _this.$emit("confimClick", arrNew);

          focusFieldConfigDetail({
            moveLocation: moveLocation,
            focusFieldConfigDetailList: listDrag,
            configType: _this.statusType
          })
            .then(res => {
              if (res.code == 0) {
                _this.commonQueryRequest();
              }
            })
            .catch(res => {
              // _this.commonQueryRequest();
            });
        }
      });
    },
    idFun () {
      //自己建id
      let date = new Date().valueOf();
      let num = parseInt(1000000 * Math.random());
      let strId = date.toString() + num.toString();
      return strId;
    },
    handleDragStart (node, ev) {
      // this.treeId = node.data.id;
      if (node.data.name == "自定义分组") {
        return false;
      }
      if (!this.bigStatus) {
        return false;
      }
    },
    handleDragEnter (draggingNode, dropNode, ev) { },
    handleDragLeave (draggingNode, dropNode, ev) { },
    handleDragOver (draggingNode, dropNode, ev) { },
    handleDragEnd (draggingNode, dropNode, dropType, ev) {
      //分组拖拽
      let moveLocation = "";
      if (dropType == "before") {
        moveLocation = "up";
      } else {
        moveLocation = "down";
      }
      focusFieldGroup({
        moveLocation: moveLocation,
        focusFieldGroupListVOList: this.menu[0].children,
        groupType: this.statusType
      }).then(res => {
        if (res.code == 0) {
          this.manageListRequest();
        }
      });
    },
    handleDrop (draggingNode, dropNode, dropType, ev) { },
    allowDrag (draggingNode, dropNode, type) {
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },
    allowDrop (draggingNode, dropNode, type) {
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          // 向上拖拽 || 向下拖拽
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理
        return false;
      }
    },
    sort (draggingNode, dropNode, type, event) {
      //  拖拽之后的重新组合的数组
      let obj = {
        aboveId: "",
        arr: []
      };
      obj.aboveId = dropNode.data.aboveId;
      for (let item of dropNode.parent.childNodes) {
        obj.arr.push(item.data.id);
      }
    },
    handleTextareaKeydown () {
      const e = window.event || arguments[0];
      if (e.key === "Enter" || e.code === "Enter" || e.keyCode === 13) {
        e.returnValue = false;
        return false;
      }
    },
    // handleNodeClick(item) {
    nodeClick (item, flag) {
      this.currentVisibleNew = item;
      this.currentData = item;
      this.currentDataNew = item;
      this.currentDataId = item.id;
      this.currentKey = null;
      this.fetchTreeData();
      this.isCheck = false;
      if (item.name == "自定义分组") {
        this.currentDataId = null;
        // this.commonQueryRequest();
        return false;
      } else if (item.name == "无分组") {
        this.currentDataId = null;
        this.commonQueryRequest();
      } else {
        this.groupId = this.currentData.id;
        this.commonQueryRequest();
      }
      if (item.children && item.children.length > 0) {
        if (item.fold === undefined) {
          this.$set(item, "fold", flag);
        } else {
          item.fold = flag;
        }
      }
    },
    cancelSaveClick () {
      //取消，继续编辑
      this.dialogVisibleNew = false;
    },
    confinSaveClick () {
      this.$emit("saveChildClick");

      //保存，进入下一组
      this.dialogVisibleNew = false;
      this.currentData = this.currentVisibleNew;
      this.currentDataNew = this.currentVisibleNew;
      this.currentDataId = this.currentVisibleNew.id;
      this.currentKey = null;
      this.fetchTreeData();
      // if (!this.bigStatus) {
      //   return false;
      // }s

      this.isCheck = false;
      this.moveFlag = true;
      if (this.currentVisibleNew.name == "自定义分组") {
        this.currentDataId = null;
        // this.commonQueryRequest();
        return false;
      } else if (this.currentVisibleNew.name == "无分组") {
        this.currentDataId = null;
        this.commonQueryRequest();
      } else {
        this.groupId = this.currentData.id;
        this.commonQueryRequest();
      }
      // if (
      //   this.currentVisibleNew.children &&
      //   this.currentVisibleNew.children.length > 0
      // ) {
      //   if (this.currentVisibleNew.fold === undefined) {
      //     this.$set(this.currentVisibleNew, "fold", flag);
      //   } else {
      //     this.currentVisibleNew.fold = flag;
      //   }
      // }
    },
    isSame () {
      let flag = true; //false证明数组发生变化  true无变化
      let flagNew = true;
      //如果前后两个数组长度不一致，证明数组发生的变化，将flag赋值为false
      if (this.dataListDelete.length != this.dataListSame.length) {
        flag = false;
      } else {
        //数组长度没变化，则进行轮询检查新数组的QuestionID是否都存在前一个数组之中
        for (var i = 0; i < this.dataListSame.length; i++) {
          flag = this.dataListDelete.some(xiaoitem => {
            return xiaoitem.idNew == this.dataListSame[i].idNew;
          });
          if (flag == false) {
            flagNew = false;
            break;
          }
        }
      }
      return flagNew;
    },
    deleteFieldClick () {
      //删除
    },
    async beforeAvatarUpload (file) {
      //批量上传
      this.videoValidation = true;
      return new Promise(async (resolve, reject) => {
        const isLt2M = file.size / 1024 / 1024 < 200;
        const rule = /\.(xls|xlsx)$/;
        if (file.name.match(rule) == null) {
          this.$message.error("只能上传excel格式!");
          this.videoValidation = false;
          return reject();
        }
        // if (!isLt2M) {
        //   this.$message.error("上传视频大小不能超过 200MB!");
        //   this.videoValidation = false;
        //   return reject();
        //   return false;
        // }
        // if (this.formStepSecond.videoList.length > 4) {
        //   this.videoValidation = false;
        //   return reject();
        // }
        resolve();
      });
    },
    async handleChange (res, file) {
      if (this.videoValidation) {
        //通过上传验证
      }
    },
    handleIntroChangeBtn (response, file) {
      let url;
      if (response.code == 0) {
        url = response.data;
        // let imgObj = new Image();
        // imgObj.src = url;
        // this.form.billDemo = url;
        this.$set(this.form, "billDemo", url);
        this.$set(this.form, "billDemoUrl", this.imgPath + url);
      }
      this.$forceUpdate();
      return this.imgPath + url;
    },
    beforeRemovePicBtn () {
      this.form.billDemo = "";
      this.form.billDemoUrl = "";
      this.$forceUpdate();
    },
    downloadClick () {
      //下载样例
      focusFieldExcelDemo().then(res => {
        let blob = new Blob([res], {
          type: "application/vnd.ms-excel,charset=UTF-8" //将会被放入到blob中的数组内容的MIME类型
        });
        let objectUrl = URL.createObjectURL(blob); //生成一个url
        this.downloadFile(objectUrl, `aaaaa`);
      });
    },
    downloadFile (content, filename) {
      let a = document.createElement("a");
      a.href = content;
      a.download = filename;
      a.click();
    },
    commonQueryRequest () {
      if (this.currentData.name == "自定义分组") {
        this.currentDataId = null;
      } else if (this.currentData.name == "无分组") {
        this.currentDataId = null;
      } else {
        this.groupId = this.currentData.id;
      }
      if (this.diseaseId == '') {
        return false;
      }
      let obj = {
        openDepartmentId: this.openDepartmentId,
        openDepartmentParentId: this.openDepartmentParentId,
        hospitalId: this.hospitalId,
        // teamId: this.teamId,
        configType: this.statusType,
        diseaseId: this.diseaseId,
        groupId: this.currentDataId
      };
      if (this.statusType == "team") {
        obj.teamId = this.teamId;
      } else {
        delete obj.teamId;
      }
      commonQuery(obj).then(res => {
        if (res.code == 0) {
          if (res.data) {
            // this.newId = res.data.id
            if (
              res.data.focusFieldConfigDetailList &&
              res.data.focusFieldConfigDetailList.length > 0
            ) {
              // this.dataList = JSON.parse(
              //   JSON.stringify(res.data.focusFieldConfigDetailList)
              // );
              res.data.focusFieldConfigDetailList.forEach((item, index) => {
                item.removeVisible = false;
              });
              let ConfigDetailList = JSON.parse(
                JSON.stringify(res.data.focusFieldConfigDetailList)
              );
              let ConfigDetailListNew = ConfigDetailList.map((item, index) => {
                return {
                  ...item,
                  itemIndex: index,
                  billDemo: item.billDemo,
                  standardFieldName: item.contactStandardFieldName,
                  // removeVisible: false,
                  idNew: this.idFun()
                };
              });
              this.dataList = JSON.parse(JSON.stringify(ConfigDetailListNew));
              this.dataListDelete = JSON.parse(
                JSON.stringify(ConfigDetailListNew)
              );
              this.dataListSame = JSON.parse(
                JSON.stringify(ConfigDetailListNew)
              );
              // this.dataListDelete = JSON.parse(
              //   JSON.stringify(res.data.focusFieldConfigDetailList)
              // );
              // this.dataListDelete = this.dataListDelete.map((item, index) => {
              //   return {
              //     ...item,
              //     itemIndex: index,
              //     billDemo: item.billDemo,
              //     standardFieldName: item.contactStandardFieldName
              //   };
              // });
              this.moveFlag = true;

              // this.$emit("confimClick", res.data.focusFieldConfigDetailList);
              this.$emit("confimClick", this.dataListDelete);
              // this.configParentId = res.data.id;
            } else {
              this.dataList = [];
              this.dataListDelete = [];
              this.dataListSame = [];
              this.$emit("confimClick", []);
              // this.configParentId = null;
            }
            if (res.data.id) {
              this.$emit("editFlagStatusClick", {
                newId: res.data.id,
                flag: true
              });
            } else {
              this.$emit("editFlagStatusClick", { newId: null, flag: false });
            }
          }
        }
      });
    },
    importClose () {
      this.importShow = false;
    },
    gressClose () {
      this.gressShow = false;
    },
    fieldNameInput (e) {
      this.form.fieldName = e.replace(/ +/g, "");
    },
    configClick (item, index) {
      //配置
      this.curStandardObj = item;
      this.choseBtnIndex = this.dataList.findIndex(item => {
        return item.idNew == this.curStandardObj.idNew;
      });
      this.choseBtnIndexDelete = this.dataListDelete.findIndex(item => {
        return item.idNew == this.curStandardObj.idNew;
      });

      this.tableData = [];
      this.recognitionRule = {
        ...this.recognitionRule,
        ...item,
        id: item.id || "",
        index: index
      };
      if (item.id) {
        this.getQueryRuleById();
      } else {
        this.tableData = JSON.parse(
          JSON.stringify(this.dataList[this.choseBtnIndex].focusFieldRuleList)
        );
      }
      this.dialogVisible = true;
    },
    uploadServerLog (params) {
      this.percentage = 0;
      const file = params.file;
      const rule = /\.(xls|xlsx)$/;
      if (file.name.match(rule) == null) {
        this.$message.error("只能上传excel格式!");
        return false;
      }
      this.gressShow = true;
      // 根据后台需求数据格式
      const form = new FormData();

      // 文件对象
      form.append("file", file);
      form.append("configType", this.statusType);
      // form.append("configParentId", this.configParentId);
      form.append("diseaseId", this.diseaseId);
      form.append("hospitalId", this.hospitalId);
      if (this.currentDataId) {
        form.append("groupId", this.currentDataId);
      }
      if (this.openDepartmentId) {
        form.append("openDepartmentId", this.openDepartmentId);
      }
      if (this.openDepartmentParentId) {
        form.append("openDepartmentParentId", this.openDepartmentParentId);
      }
      if (this.statusType == "team") {
        form.append("teamId", this.teamId);
      }
      // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      let time = setInterval(() => {
        this.percentage++;
        if (this.percentage >= 90) {
          this.percentage = 90;
        }
      }, 100);
      axios
        .post("/admin/focusFieldConfig/upload/focusFieldExcelData", form)
        .then(res => {
          this.percentage = 100;
          clearInterval(time);
          this.gressShow = false;
          if (res.data.data.parse == "error") {
            this.importShow = true;
            this.parseDataList = res.data.data.parseDataList;
          } else {
            this.$message.success("导入成功");
            this.commonQueryRequest();
            this.importShow = false;
            this.parseDataList = [];
          }
        })
        .catch(err => {
          this.gressShow = false;
          clearInterval(time);
          this.$message.error("上传失败");
        });
    },
    // 获取规则弹框传递的列表数据
    focusFieldRuleDTOData (list) { },
    async getQueryRuleById () {
      let { code, data } = await getQueryRuleById(this.recognitionRule.id);
      if (code === 0) {
        this.tableData = data.map(item => {
          return {
            ...item,
            status: ""
          };
        });
      }
    },
    handleNewClose (done) {
      let flag = true;
      this.tableData.forEach(item => {
        if (item.valueLogic == "" || item.status !== "") {
          flag = false;
        }
      });

      if (!flag) {
        this.$message.error("请确认识别规则是否未保存");
        return false;
      }

      // 无id关闭弹框时保存一次至父组件
      if (!this.recognitionRule.id) {
        // this.$emit("ruleChange", this.tableData);
      }
      // 循环遍历数据，将状态置为""
      this.tableData = this.tableData.map((item, key) => {
        return {
          ...item,
          status: ""
        };
      });
      // let list = JSON.parse(JSON.stringify(this.dataListDelete));
      // list[this.recognitionRule.index].focusFieldRuleList = this.tableData;
      // this.dataListDelete = JSON.parse(JSON.stringify(list));
      // this.dataList = JSON.parse(JSON.stringify(list));
      this.dataList[this.choseBtnIndex].focusFieldRuleList = this.tableData;
      this.dataListDelete[
        this.choseBtnIndexDelete
      ].focusFieldRuleList = this.tableData;
      this.dataList = this.dataList.map((item, index) => {
        return {
          ...item,
          standardFieldName: item.contactStandardFieldName
        };
      });
      this.dataListDelete = this.dataListDelete.map((item, index) => {
        return {
          ...item,
          standardFieldName: item.contactStandardFieldName
        };
      });
      this.$emit("confimClick", this.dataListDelete);
      this.dialogVisible = false;
      this.$forceUpdate();
      // done();
    },
    // 新增识别规则
    addRuleItem () {
      // 判断上一个识别规则是否填写完毕 并且判断是否已保存
      // 判断是否有未保存的数据，有则给出提示
      if (this.tableData && this.tableData.length === 0) {
        this.tableData.unshift({
          valueLogic: "",
          status: "add"
        });
      } else {
        let flag = false;
        this.tableData.forEach(item => {
          if (item.status) {
            flag = true;
          }
        });
        if (flag) {
          this.$message.error("请保存识别规则");
        } else {
          this.tableData.unshift({
            valueLogic: "",
            status: "add"
          });
        }
      }
    },
    // 编辑
    async editNewClick (item, index) {
      // this.tableData[index].status = "edit";
      // 点击编辑时判断是否有未保存的数据
      let flag = false;
      this.tableData.forEach(item => {
        if (item.status) {
          flag = true;
        }
      });
      if (flag) {
        this.$message.error("请保存识别规则");
      } else {
        item.status = "edit";
      }
    },
    // 保存规则 判断是否有id
    async handleClick (row) {
      if (row.valueLogic.match(/^[ ]*$/) || !row.valueLogic) {
        row.valueLogic = row.valueLogic.replace(/\s+/g, "");
        this.$message.error("请填写识别规则");
      } else {
        this.ruleLoading = true;
        if (!this.recognitionRule.id) {
          // 无id 将数据存储保存给父元素---关闭弹框时保存给父组件
          row.status = "";
          this.ruleLoading = false;
        } else {
          // 有id 调用接口 判断有没有row.id 有的话调用编辑接口 无则调用保存接口
          // 判断有没有内容
          if (row.id) {
            // 编辑接口
            let { code, data } = await updateRule({
              ...row
            });
            if (code === 0) {
              this.ruleLoading = false;
              this.getQueryRuleById();
              this.$message("识别规则编辑成功");
            }
          } else {
            let { code, data } = await saveRule({
              id: this.recognitionRule.id,
              configParentId: this.recognitionRule.configParentId,
              focusFieldRuleList: this.tableData
            });
            if (code === 0) {
              this.ruleLoading = false;
              this.getQueryRuleById();
              this.$message("识别规则保存成功");
            }
          }
        }
      }
    },
    // 删除规则
    async deleteRule (id, index) {
      if (id) {
        // 调用接口删除
        let { code, data } = await deletedRule(id);
        if (code === 0) {
          this.$message("识别规则删除成功");
          this.getQueryRuleById();
        }
      } else {
        // 前端数组中删除
        this.tableData.splice(index, 1);
      }
    },
    fetchTreeData () {
      // 在 el-tree中 定义ref 来选中el-tree 调用setCurrentKey方法
      // 把想要高亮选中的项传入
      this.$refs.treeRefNo.setCurrentKey(this.currentKey);
      this.$refs.treeRef.setCurrentKey(this.currentKey);
    },

    addIndexValueQuantitativemClick () {
      //加一条
      let obj = {
        lower: "",
        upper: "",
        unit: "",
        resultProperty: this.resultProperty,
        fourValue: ""
      };
      this.form.focusFieldPushIntervalList.push(obj);
    },
    addIndexValueQuantitativesClick () {
      //加一条
      let obj = {
        unit: "",
        fourValue: ""
      };
      this.form.indexValueListQuantitatives.push(obj);
    },
    deleteIndexValueQuantitativemClick (index) {
      this.form.focusFieldPushIntervalList.splice(index, 1);
    },
    deleteIndexValueQuantitativesClick (index) {
      this.form.indexValueListQuantitatives.splice(index, 1);
    },
    getUnitsRequest () {
      getUnits({
        standardFieldId: this.form.standardFieldId
      }).then(res => {
        if (res.code == 0) {
          if (res.data && res.data.unitList) {
            this.unitList = res.data.unitList;
          }
          if (res.data && res.data.referencesList) {
            this.referencesList = res.data.referencesList;
          }
        }
      });
    },
    async queryDepartment (queryString, cb) {
      // let res = await getPlaceList({
      //   keyWord: queryString,
      //   type: 2
      // });
      // if (res.code === 0) {
      //   res.data.forEach(ele => {
      //     ele.value = ele.name;
      //   });
      //   this.departmentList = res.data;
      //   cb(this.departmentList);
      // }
      let res = await getUnits({
        standardFieldId: this.form.standardFieldId
      });
      if (res.code === 0) {
        if (res.data && res.data.unitList) {
          // res.data.unitList.forEach(ele => {
          //   ele.value = ele;
          // });
          // this.departmentList = res.data;
          // cb(this.departmentList);
          this.unitList = res.data.unitList;
          cb(this.unitList);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.btn-box {
  display: flex;
  // margin-bottom: 20px;
  align-items: center;

  p {
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 12px;
  }

  h1 {
    font-size: 14px;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    margin-right: 20px;
  }
}

.flex {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.downloadClass {
  width: 80px;
  height: 32px;
  margin-right: 10px;
  color: #fff;
  // background-color: #1a7bfc;
  color: #1a7bfc;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  line-height: 32px;
  font-size: 12px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  text-decoration: none;

  img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
}

.upload-box {
  width: 80px;
  height: 32px;
  position: relative;
  display: inline-block;
  margin-right: 10px;
}

.avatar-uploader {
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;

  /deep/.el-upload--text {
    width: 100%;
    height: 100%;
  }
}

.uploadBtn {
  position: absolute;
  left: 0;
  top: 0;
}

/deep/.el-select--medium {
  width: 100%;
}

/deep/.el-dialog__body {
  padding: 10px 50px 30px 20px;
}

/deep/.el-textarea__inner {
  padding-bottom: 25px;
  min-height: auto !important;
  resize: none;
}

/deep/ .el-textarea .el-input__count {
  height: 20px;
  line-height: 20px;
  background: none;
  right: 18px;
}

/deep/.el-form-item .el-form-item {
  margin-bottom: 20px !important;
}

/deep/.el-tree {
  background: #fafafa;
}

.left-menu {
  background: #fafafa;
  // background: red;
  border-radius: 6px;
  padding: 15px 15px 30px 15px;
  margin-right: 5px;
}

.add-box {
  margin-bottom: 20px;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ruleForm-title-left {
    display: flex;
    align-items: center;

    .span-title {
      display: inline-block;
      width: 4px;
      height: 15px;
      background: #1a7bfc;
      margin: 0 10px 0 0;
    }

    .span-text {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
    }
  }
}

.pagination-box {
  margin-top: 20px;
  text-align: right;
}

.table-first {
  display: flex;
  align-items: center;
  margin: 0 auto;

  img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }
}

.management-box-left {
  float: left;
  width: 50%;
}

// /deep/.el-table__body-wrapper {
//   height: auto !important;
// }

.el-tree /deep/ .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

//父节点
.el-tree /deep/ .svgIcona {
  background: url("../../../assets/images/folder.png") no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

//目录
.el-tree /deep/ .svgIconb {
  background: url(../../../assets/images/folderOpen.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

//章节
.el-tree /deep/ .svgIconc {
  background: url("../../../assets/images/file.png") no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

//有子节点 且已展开
.el-tree /deep/ .el-tree-node__expand-icon.expanded.el-icon-caret-right .svgIconb {
  background: url(../../../assets/images/folder.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

.el-tree /deep/ .el-tree-node__expand-icon.expanded.el-icon-caret-right .svgIconb {
  background: url(../../../assets/images/folder.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 26px;
  height: 26px;
  font-size: 16px;
  background-size: 20px;
}

.el-tree /deep/.el-tree-node__label {
  font-size: 14px;
  float: left;
  width: 200px;
  margin: 3px 0 0 0;
  white-space: pre-line !important;
  word-break: break-all !important;
  word-wrap: break-word !important;
}

.el-tree /deep/.el-tree-node__expand-icon.is-leaf {
  float: left;
}

.el-tree /deep/.el-tree-node__expand-icon.expanded {
  float: left;
}

.el-tree /deep/.el-tree-node__content {
  //   display: block;
  min-width: 300px;
  height: auto;
  cursor: pointer;
  white-space: normal;
  align-items: inherit;
  overflow: hidden;
}

/deep/.el-tree-node>.el-tree-node__children {
  overflow: visible;
}

.el-tree /deep/.el-tree-node__content>.el-tree-node__expand-icon {
  padding: 0;
  float: left;
}

.el-tree /deep/.el-tree-node__content span {
  display: inline-block;
  float: left;
  line-height: 20px;
  height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-tree /deep/ .is-current {
  color: #1a7bfc;
}

.el-tree /deep/ .is-current .el-tree-node__children {
  color: #606266;
}

.custom-tree-node {
  position: relative;
  width: 280px;
  display: flex;

  .svgIconc-icon {
    float: left;
  }

  .label-name {
    font-size: 14px;
    float: left;
    width: 236px;
    margin: 3px 0 0 0;
    // white-space: pre-line !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
  }
}

.el-dialog {
  .dialog-title {
    .sub-title {
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
    }
  }

  .dialog-footer {
    display: block;
    text-align: center !important;
  }
}

.group-box {
  overflow: hidden;
  text-align: center;
  padding: 0 80px;

  .errorBig {
    width: 74px;
    height: 74px;
  }

  .group-title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 32px;
    margin-top: 22px;
  }

  .group-text {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 16px;
  }

  .error-group-box {
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding: 25px 40px 25px;

    .error-group-box-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      text-align: left;
    }

    .error-group-box-content {
      height: 70px;
      overflow-y: auto;
      margin-top: 10px;

      ul {
        li {
          display: flex;
          align-items: center;

          img {
            width: 14px;
            height: 14px;
          }

          span {
            margin-left: 8px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }
    }

    .error-group-box-content::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .error-group-box-content::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #ededed;
    }

    .error-group-box-content::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #f8f8f8;
    }
  }
}

.tips-box {
  width: 240px;
  min-height: 100px;
  position: absolute;
  left: -90px;
  top: -40px;
  // margin-left: -50px;
  z-index: 23;
  // background: rgba(0, 0, 0, 0.8);
  background: #fff;
  padding: 7px 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.tips-box-center {
  // height: 90px;
  overflow-y: auto;
  padding: 0 10px;
}

.tips-box-content {
  color: #000;
}

.tips-box-content div {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tips-box .san-icon {
  width: 0;
  height: 0;
  border-left: 10px solid rgba(255, 255, 255, 1);
  // border-left: 10px solid red;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  position: absolute;
  left: 240px;
  top: 45px;
}

.tips-box-center::-webkit-scrollbar {
  width: 2px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 90px;
}

.tips-box-center::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.2);
}

.tips-box-center::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.table-content {
  position: relative;
  // height: 460px;
  // overflow-x: auto;
}

.table-content::-webkit-scrollbar {
  width: 2px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 90px;
}

.table-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.2);
}

.table-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.table-content-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}

.index-value-box {
  .index-value-box-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    span {
      display: inline-block;
      margin: 0 5px;
    }

    .deleteIndexValue {
      color: #1a7bfc;
      cursor: pointer;
    }
  }

  .addIndexValue {
    border: 1px dashed #ededed;
    text-align: center;
    line-height: 30px;
    border-radius: 4px;
    cursor: pointer;
  }
}

/deep/.el-loading-spinner {
  margin-top: -5px;
}

.tree-box-content {
  width: 300px;
  height: 460px;
  padding: 5px 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.tree-box-content::-webkit-scrollbar {
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 90px;
}

.tree-box-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.2);
}

.tree-box-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #ebeef5;
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

// .table-content .el-table__body-wrapper{
//   height: 460px !important;
// }</style>
